import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-logo">Qbeta Academy</h3>
            <p className="footer-description">
              Qbeta Academy offers specialized career programs in Data Analytics, Data Engineering, and Data Science with AI. Learn online from anywhere in India or join offline classroom programs in Bhubaneswar to build a successful data career.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Programs</h4>
            <ul className="footer-links">
              <li><Link to="/academy/data-analytics-course">Data Analytics Course</Link></li>
              <li><Link to="/academy/data-engineering-course">Data Engineering Course</Link></li>
              <li><Link to="/academy/data-science-ai-course">Data Science with AI</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Resources</h4>
            <ul className="footer-links">
              <li><Link to="/academy/about">About</Link></li>
              <li><Link to="/academy/contact">Contact</Link></li>
              <li><Link to="/academy/why-us">Why Us</Link></li>
              <li><Link to="/academy/blog">Blog</Link></li>
            </ul>
          </div>

          <div className="footer-section social-section">
            <h4 className="footer-title">Connect With Us</h4>
            <div className="social-links">
              <a href="https://linkedin.com/company/qbeta-academy" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM0 8h5v14H0V8zm7.5 0h4.8v2h.1c.67-1.2 2.3-2.4 4.7-2.4 5 0 5.9 3.3 5.9 7.6V22H17v-6.3c0-1.5 0-3.4-2.1-3.4-2.1 0-2.4 1.6-2.4 3.3V22H7.5V8z" />
                </svg>
              </a>

              <a href="https://instagram.com/qbeta_academy" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.9.3 2.4.5.6.2 1 .5 1.4 1 .4.4.8.9 1 1.4.2.5.4 1.2.5 2.4.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.3 1.9-.5 2.4-.2.6-.5 1-1 1.4-.4.4-.9.8-1.4 1-.5.2-1.2.4-2.4.5-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.9-.3-2.4-.5-.6-.2-1-.5-1.4-1-.4-.4-.8-.9-1-1.4-.2-.5-.4-1.2-.5-2.4C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.3-1.9.5-2.4.2-.6.5-1 1-1.4.4-.4.9-.8 1.4-1 .5-.2 1.2-.4 2.4-.5C8.4 2.2 8.8 2.2 12 2.2zm0 3.1a6.7 6.7 0 100 13.4A6.7 6.7 0 0012 5.3zm0 10.9a4.2 4.2 0 110-8.4 4.2 4.2 0 010 8.4zm6.6-11.9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"/>
                </svg>
              </a>

              <a className="youtube" href="https://youtube.com/@qbeta-academy" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M23.5 6.2s-.2-1.6-.8-2.3c-.8-.9-1.7-.9-2.1-1C16.8 2 12 2 12 2s-4.8 0-8.6.9c-.4.1-1.3.1-2.1 1C.2 4.6 0 6.2 0 6.2S-.1 8-.1 9.8v.4C0 12.1 0 14 0 14s.2 1.6.8 2.4c.8.9 1.9.9 2.4 1 1.8.3 7.3.8 8.8.8s4.8-.1 8.6-.9c.4-.1 1.3-.1 2.1-1 .6-.8.8-2.4.8-2.4s.1-1.9.1-3.7v-.4c0-1.8-.1-3.6-.1-3.6zM9.6 15.5V8.5l6.4 3.5-6.4 3.5z"/>
                </svg>
              </a>

              <a href="https://facebook.com/qbetaacademy" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M22 12.1C22 6.5 17.5 2 11.9 2S2 6.5 2 12.1C2 17 5.7 21 10.5 21v-6.6H8.2V12h2.3V9.8c0-2.3 1.4-3.6 3.5-3.6 1 0 1.9.1 2.1.1v2.4h-1.2c-1 0-1.3.6-1.3 1.2V12h2.5l-.4 2.4h-2.1V21C18.3 21 22 17 22 12.1z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Qbeta Academy. All rights reserved.</p>
          <p className="footer-seo-text">
            Qbeta Academy: Career-focused learning in Data Analytics, Data Engineering, Data Science with AI. Online courses across India and offline classroom learning in Bhubaneswar.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
